import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PhysicalPersonalInformation from './PhysicalPersonalInformation';
import LegalPersonalInformation from './LegalPersonalInformation';
import { updateCascoForm } from '../../../../redux/modules/cascoClaim';
import { APPLICANT_TYPES } from '../../../../constants';

import styles from '../../../CompensationContainer/Steps/steps.module.scss';

const CascoPersonalInformationStep = ({
  goNext,
  step,
  goPrevious,
  params: { setStepNavigationBox, formLanguage, scrollTo },
}) => {
  const dispatch = useDispatch();

  const cascoClaim = useSelector((store) => store.cascoClaim, shallowEqual);
  const initialData = cascoClaim.personalData;
  const { status } = cascoClaim;

  const handleNext = (data) => {
    dispatch(
      updateCascoForm({
        name: 'personalData',
        data: {
          ...data,
          applicantType: status,
          citizenship: initialData.citizenship,
        },
      }),
    );
    ['compensation', 'attachments'].forEach((section) => {
      dispatch(
        updateCascoForm({
          name: section,
          data: {
            isOtherApplicant: ['other', 'otherLegal'].includes(data.applicantToVictim),
            isPhysicalEntity: status === 1,
            isCarParked: data.participantIs === 'isParked',
          },
        }),
      );
    });
    goNext(step);
  };
  return (
    <div ref={scrollTo} className={styles.formContainer}>
      {initialData && status === APPLICANT_TYPES[0].value && (
        <PhysicalPersonalInformation
          initialData={initialData}
          onFormSubmit={handleNext}
          formLanguage={formLanguage}
          setStepNavigationBox={setStepNavigationBox}
          goPrevious={goPrevious}
        />
      )}
      {initialData && status === APPLICANT_TYPES[1].value && (
        <LegalPersonalInformation
          initialData={initialData}
          onFormSubmit={handleNext}
          formLanguage={formLanguage}
          setStepNavigationBox={setStepNavigationBox}
          goPrevious={goPrevious}
        />
      )}
    </div>
  );
};

CascoPersonalInformationStep.propTypes = {
  goNext: PropTypes.func.isRequired,
  goPrevious: PropTypes.func.isRequired,
  step: PropTypes.shape({
    n: PropTypes.number.isRequired,
  }).isRequired,
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
    scrollTo: PropTypes.func.isRequired,
    formLanguage: PropTypes.string,
  }).isRequired,
};

export default CascoPersonalInformationStep;
